import { useLocation, useParams } from "react-router-dom";

import styles from "./PortfolioBoard.module.css";
import PhotoBoard from "Page/common/PhotoBoard";

export default function PortfolioBoard() {
  const { title } = useLocation().state;
  const { category_id } = useParams();

  return (
    <div className={styles.PortfolioBoard}>
      <PhotoBoard
        title={title}
        api="portfolio"
        to="portfolio"
        category_id={category_id}
      />
    </div>
  );
}
